var _defs, _sodipodiNamedview;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 2589.3333,
    height: 925.33331,
    viewBox: "0 0 2589.3333 925.33331",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,694 H 1942 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,925.33333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(874.3208,281.499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.518,6.1 12.777,14.653 12.777,25.656 0,10.83 -4.303,19.25 -12.906,25.27 -8.607,6.014 -20.566,9.024 -35.88,9.024 H -93.056 V -9.153 h 57.047 C -20.521,-9.153 -8.519,-6.104 0,0 m -6.324,84.059 c 7.054,5.584 10.583,13.537 10.583,23.85 0,9.968 -3.529,17.703 -10.583,23.207 -7.059,5.499 -16.952,8.162 -29.685,7.993 h -57.047 v -63.43 h 57.047 c 12.733,0 22.626,2.792 29.685,8.38 M 7.228,143.363 C 17.464,135.37 22.586,124.323 22.586,110.23 22.586,99.57 19.618,90.634 13.681,83.414 7.744,76.194 -0.561,71.465 -11.229,69.232 2.021,67.513 12.346,62.613 19.747,54.535 27.144,46.453 30.846,36.229 30.846,23.852 30.846,8.381 25.079,-3.654 13.552,-12.247 2.021,-20.845 -13.983,-25.14 -34.46,-25.14 h -76.407 v 180.493 h 75.632 c 18.069,0 32.222,-3.997 42.463,-11.99",
    style: {
      fill: "#252525",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(1055.3975,320.3057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -43.366,97.466 -86.216,0 Z M 6.969,-15.986 H -93.186 l -21.166,-47.96 h -19.102 l 81.311,180.235 h 18.585 L 47.754,-63.946 h -19.36 z",
    style: {
      fill: "#252525",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(1255.1875,344.543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 15.746 v -66.009 c -8.776,-7.392 -18.973,-13.194 -30.588,-17.404 -11.616,-4.215 -23.45,-6.317 -35.493,-6.317 -17.037,0 -32.742,4.126 -47.108,12.376 -14.371,8.251 -25.774,19.423 -34.203,33.52 -8.433,14.093 -12.648,29.48 -12.648,46.155 0,16.671 4.215,31.973 12.648,45.896 8.429,13.924 19.917,24.967 34.46,33.134 14.54,8.162 30.415,12.248 47.625,12.248 12.217,0 24.046,-2.152 35.494,-6.447 C -2.625,82.854 7.486,76.838 16.263,69.103 L 5.937,56.469 c -7.401,6.873 -15.919,12.158 -25.554,15.857 -9.64,3.695 -19.618,5.544 -29.944,5.544 -13.939,0 -26.76,-3.396 -38.461,-10.185 -11.705,-6.793 -20.998,-15.946 -27.878,-27.461 -6.885,-11.518 -10.326,-24.153 -10.326,-37.903 0,-13.924 3.441,-26.687 10.326,-38.291 6.88,-11.603 16.217,-20.801 28.007,-27.59 11.786,-6.793 24.652,-10.184 38.59,-10.184 8.604,0 17.166,1.418 25.685,4.255 8.517,2.836 16.39,6.832 23.618,11.989 z",
    style: {
      fill: "#252525",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(1399.2217,417.9004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.776,2.49 -17.036,3.739 -24.78,3.739 -12.391,0 -22.328,-2.449 -29.814,-7.349 -7.486,-4.899 -11.229,-11.562 -11.229,-19.983 0,-7.393 2.065,-13.408 6.195,-18.049 4.13,-4.641 9.204,-8.296 15.23,-10.959 6.022,-2.667 14.282,-5.631 24.781,-8.895 12.217,-3.61 22.069,-7.18 29.555,-10.701 7.486,-3.525 13.85,-8.638 19.102,-15.342 5.247,-6.704 7.873,-15.56 7.873,-26.558 0,-9.629 -2.711,-18.138 -8.131,-25.527 -5.421,-7.393 -13.036,-13.109 -22.845,-17.147 -9.809,-4.041 -21.082,-6.059 -33.815,-6.059 -12.563,0 -24.824,2.489 -36.783,7.477 -11.963,4.984 -22.243,11.604 -30.847,19.854 l 8.26,14.697 c 8.087,-7.908 17.465,-14.095 28.137,-18.564 10.668,-4.473 21.167,-6.704 31.491,-6.704 13.766,0 24.692,2.792 32.783,8.38 8.087,5.584 12.132,13.105 12.132,22.562 0,7.562 -2.066,13.75 -6.195,18.565 -4.13,4.81 -9.208,8.508 -15.23,11.087 -6.025,2.579 -14.455,5.584 -25.297,9.025 -12.22,3.779 -22.029,7.348 -29.427,10.7 -7.401,3.353 -13.68,8.336 -18.843,14.955 -5.162,6.616 -7.743,15.254 -7.743,25.914 0,9.109 2.581,17.102 7.743,23.98 5.163,6.873 12.39,12.159 21.683,15.857 9.292,3.695 20.045,5.544 32.266,5.544 9.81,0 19.658,-1.462 29.557,-4.383 9.893,-2.926 18.625,-6.793 26.2,-11.604 L 24.265,-10.701 C 16.863,-6.059 8.776,-2.494 0,0",
    style: {
      fill: "#252525",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 1516.668,256.359 h -47.238 v 180.75 h 47.238 z",
    style: {
      fill: "#026f95",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(1655.2793,300.9668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 7.055,4.295 12.56,10.398 16.521,18.308 3.957,7.904 5.937,16.928 5.937,27.074 0,10.313 -2.109,19.423 -6.324,27.331 -4.219,7.905 -10.028,14.053 -17.424,18.436 -7.401,4.383 -15.835,6.575 -25.297,6.575 H -56.271 V -6.446 h 32.007 C -15.145,-6.446 -7.058,-4.299 0,0 M 24.651,124.798 C 39.191,117.232 50.505,106.62 58.596,92.954 66.683,79.288 70.728,63.6 70.728,45.897 70.728,28.19 66.639,12.462 58.467,-1.289 50.291,-15.044 38.76,-25.7 23.877,-33.263 8.99,-40.828 -8.091,-44.607 -27.361,-44.607 h -76.149 v 180.75 h 77.955 c 18.929,0 35.662,-3.783 50.206,-11.345",
    style: {
      fill: "#026f95",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(356.0161,185.0303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -95.959 c -1.959,0 -3.673,0.703 -5.142,2.111 -1.409,1.407 -2.113,3.121 -2.113,5.141 v 150.046 c 0,2.021 0.704,3.734 2.113,5.141 1.469,1.471 3.183,2.205 5.142,2.205 H 0 Z m 0,259.776 v -72.543 h -95.959 c -1.959,0 -3.673,0.704 -5.142,2.112 -1.409,1.408 -2.113,3.123 -2.113,5.142 v 58.036 c 0,1.958 0.704,3.673 2.113,5.142 1.469,1.408 3.183,2.111 5.142,2.111 z m 0,21.028 h -93.388 v 3.49 c 0,3.735 1.316,6.918 3.948,9.551 2.633,2.694 5.816,4.039 9.551,4.039 H -65.197 0 Z",
    style: {
      fill: "#bbe0ee",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(312.2144,523.6855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -28.649 h -11.57 v 28.558 c 0.195,-0.257 0.409,-0.502 0.643,-0.735 1.408,-1.408 3.122,-2.112 5.142,-2.112 1.96,0 3.643,0.704 5.051,2.112 C -0.463,-0.555 -0.219,-0.28 0,0",
    style: {
      fill: "#d9d9d9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(254.7314,155.3701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,3.227 0.888,6.102 2.662,8.631 0.503,0.734 1.085,1.437 1.745,2.111 3,2.94 6.582,4.408 10.744,4.408 4.163,0 7.745,-1.468 10.744,-4.408 0.661,-0.674 1.242,-1.377 1.744,-2.111 1.776,-2.529 2.664,-5.404 2.664,-8.631 0,-4.164 -1.47,-7.746 -4.408,-10.744 -2.999,-2.94 -6.581,-4.408 -10.744,-4.408 -4.162,0 -7.744,1.468 -10.744,4.408 C 1.469,-7.746 0,-4.164 0,0",
    style: {
      fill: "#333333",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(257.3936,164.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.774,-2.529 -2.662,-5.404 -2.662,-8.631 h -6.153 c -1.592,0 -2.969,0.549 -4.132,1.652 -1.163,1.163 -1.745,2.54 -1.745,4.133 V 0.367 C -13.489,0.123 -12.233,0 -10.927,0 Z M 98.623,0 V -8.631 H 27.641 c 0,3.227 -0.888,6.102 -2.664,8.631 z M 54.821,331.035 H 98.623 V 318.913 H 33.425 v 5.327 c 0,1.897 0.674,3.49 2.021,4.774 1.285,1.349 2.877,2.021 4.775,2.021 h 3.03 z m 0,28.65 c -0.219,-0.28 -0.464,-0.556 -0.735,-0.826 -1.407,-1.408 -3.09,-2.112 -5.05,-2.112 -2.02,0 -3.734,0.704 -5.142,2.112 -0.234,0.233 -0.448,0.477 -0.643,0.734 -0.979,1.244 -1.47,2.682 -1.47,4.316 v 6.153 l 0.093,0.826 -0.093,0.826 c 0,4.592 1.654,8.51 4.959,11.754 3.245,3.305 7.193,4.959 11.846,4.959 H 98.623 V 374.01 H 58.586 c -0.673,0 -1.225,-0.214 -1.653,-0.643 -0.49,-0.49 -0.735,-1.041 -0.735,-1.653 l -0.091,-0.826 0.091,-0.826 v -6.153 c 0,-1.582 -0.459,-2.99 -1.377,-4.224",
    style: {
      fill: "#565a61",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(356.0161,372.2632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -22.589 h -95.959 c -1.959,0 -3.673,-0.734 -5.142,-2.204 -1.409,-1.408 -2.113,-3.121 -2.113,-5.142 v -150.046 c 0,-2.019 0.704,-3.734 2.113,-5.141 1.469,-1.408 3.183,-2.111 5.142,-2.111 H 0 v -21.029 h -73.646 c -0.501,0.734 -1.083,1.437 -1.744,2.111 -2.999,2.94 -6.581,4.408 -10.743,4.408 -4.163,0 -7.744,-1.468 -10.744,-4.408 -0.661,-0.674 -1.243,-1.377 -1.746,-2.111 h -10.926 c -1.307,0 -2.562,0.123 -3.765,0.367 -3.138,0.687 -5.923,2.25 -8.356,4.684 -3.368,3.367 -5.051,7.406 -5.051,12.121 V 76.309 c 0,4.774 1.683,8.846 5.051,12.212 3.367,3.367 7.407,5.05 12.121,5.05 H -93.388 0 V 72.543 h -95.959 c -1.959,0 -3.673,-0.703 -5.142,-2.111 -1.409,-1.469 -2.113,-3.183 -2.113,-5.142 V 7.254 c 0,-2.019 0.704,-3.733 2.113,-5.142 C -99.632,0.705 -97.918,0 -95.959,0 Z",
    style: {
      fill: "#026f95",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(356.0161,371.8037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 92.377 Z M 0,48.761 H 99.541 Z M 99.541,43.435 H 0 Z M 0,93.572 h 89.807 z m 67.401,-310.467 c 0,3.247 0.888,6.124 2.663,8.633 -1.775,-2.509 -2.663,-5.386 -2.663,-8.633 M 0,110.651 h 64.278 z m 40.221,12.122 h 11.57 z m 0,30.394 c 0.243,-0.305 0.489,-0.581 0.733,-0.826 1.408,-1.408 3.092,-2.112 5.05,-2.112 2.022,0 3.735,0.704 5.142,2.112 0.246,0.245 0.46,0.491 0.645,0.735 -0.185,-0.244 -0.399,-0.49 -0.645,-0.735 -1.407,-1.408 -3.12,-2.112 -5.142,-2.112 -1.958,0 -3.642,0.704 -5.05,2.112 -0.244,0.245 -0.49,0.521 -0.733,0.826 m 54.82,-361.429 c 1.775,-2.509 2.663,-5.386 2.663,-8.633 0,3.247 -0.888,6.124 -2.663,8.633 m -95.041,0 h 70.064 c 0.49,0.735 1.071,1.44 1.744,2.112 3,2.939 6.582,4.408 10.744,4.408 4.163,0 7.745,-1.469 10.743,-4.408 0.675,-0.672 1.256,-1.377 1.746,-2.112 h 10.927 c 1.286,0 2.54,0.123 3.765,0.367 -1.225,-0.244 -2.479,-0.367 -3.765,-0.367 H 95.041 c -0.49,0.735 -1.071,1.44 -1.746,2.112 -2.998,2.939 -6.58,4.408 -10.743,4.408 -4.162,0 -7.744,-1.469 -10.744,-4.408 -0.673,-0.672 -1.254,-1.377 -1.744,-2.112 z m 92.377,21.03 c 1.958,0 3.673,0.703 5.142,2.111 1.408,1.406 2.113,3.121 2.113,5.141 V -29.936 -179.98 c 0,-2.02 -0.705,-3.735 -2.113,-5.141 l -5.142,-2.111 H 0 Z M 97.519,2.113 c 1.408,1.408 2.113,3.122 2.113,5.142 v 36.18 -36.18 c 0,-2.02 -0.705,-3.734 -2.113,-5.142 L 92.377,0 c 1.958,0 3.673,0.705 5.142,2.113 m 2.113,46.648 v 16.53 c 0,1.958 -0.705,3.672 -2.113,5.141 1.408,-1.469 2.113,-3.183 2.113,-5.141 v -16.53 h -0.091 v -5.326 h 0.091 z M 0,-22.589 h 92.377 c 1.958,0 3.673,-0.733 5.142,-2.204 l 2.113,-5.143 c 0,2.023 -0.705,3.736 -2.113,5.143 -1.469,1.471 -3.184,2.204 -5.142,2.204 z m 0,202.754 h 36.454 c 4.654,0 8.602,-1.653 11.846,-4.959 3.306,-3.245 4.959,-7.162 4.959,-11.753 v -5.969 c 0,-1.715 -0.489,-3.184 -1.468,-4.408 v -30.303 h 5.601 c 1.897,0 3.52,-0.672 4.867,-2.021 1.347,-1.284 2.019,-2.877 2.019,-4.774 v -5.327 h 12.03 c 3.734,0 6.917,-1.345 9.55,-4.039 2.633,-2.633 3.949,-5.816 3.949,-9.55 v -3.49 h 16.161 c 4.714,0 8.754,-1.684 12.12,-5.051 3.369,-3.366 5.051,-7.438 5.051,-12.211 v -267.4 c 0,-4.715 -1.682,-8.754 -5.051,-12.121 -2.447,-2.449 -5.233,-4.01 -8.355,-4.684 v -3.212 c 0,-1.594 -0.581,-2.971 -1.745,-4.133 -1.162,-1.104 -2.54,-1.655 -4.133,-1.655 h -6.151 c 0,-4.162 -1.469,-7.744 -4.409,-10.742 -2.998,-2.939 -6.58,-4.408 -10.743,-4.408 -4.162,0 -7.744,1.469 -10.744,4.408 -2.938,2.998 -4.407,6.58 -4.407,10.742 H 0 v 8.633 21.03 130.117 h 99.541 v 5.233 H 0 99.541 v -5.233 H 0 v 5.233 29.293 V 0 v 43.435 5.326 23.782 21.029 17.079 12.122 h 40.221 v 30.394 c -0.919,1.225 -1.378,2.664 -1.378,4.317 v 5.969 c 0,0.611 -0.245,1.163 -0.735,1.652 -0.429,0.429 -0.98,0.643 -1.654,0.643 H 0 Z M 92.377,72.543 97.519,70.432 c -1.469,1.408 -3.184,2.111 -5.142,2.111 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path62"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 356.016,415.239 H 252.802 v 5.326 h 103.214 z m 0,-100.551 H 252.802 v 5.233 h 103.214 z",
    style: {
      fill: "#565a61",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(356.0161,371.8037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 92.377 M 0,48.761 H 99.541 M 0,-187.232 H 92.377 M 0,93.572 H 89.807 M 67.401,-216.895 c 0,3.247 0.888,6.124 2.663,8.633 M 0,110.651 h 64.278 m -24.057,12.122 h 11.57 m -11.57,30.394 c 0.243,-0.305 0.489,-0.581 0.733,-0.826 1.408,-1.408 3.092,-2.112 5.05,-2.112 2.022,0 3.735,0.704 5.142,2.112 0.246,0.245 0.46,0.491 0.645,0.735 m 43.25,-361.338 c 1.775,-2.509 2.663,-5.386 2.663,-8.633 M 0,-208.262 h 70.064 c 0.49,0.735 1.071,1.44 1.744,2.112 3,2.939 6.582,4.408 10.744,4.408 4.163,0 7.745,-1.469 10.743,-4.408 0.675,-0.672 1.256,-1.377 1.746,-2.112 h 10.927 c 1.286,0 2.54,0.123 3.765,0.367 m -17.356,20.663 c 1.958,0 3.673,0.703 5.142,2.111 m 0,0 c 1.408,1.406 2.113,3.121 2.113,5.141 V -29.936 M 0,-51.882 h 99.541 v -5.233 H 0 m 99.632,27.179 c 0,2.023 -0.705,3.736 -2.113,5.143 -1.469,1.471 -3.184,2.204 -5.142,2.204 L 0,-22.589 M 92.377,0 c 1.958,0 3.673,0.705 5.142,2.113 1.408,1.408 2.113,3.122 2.113,5.142 v 36.18 m 0,0 v 5.326 16.53 c 0,1.958 -0.705,3.672 -2.113,5.141 M 99.541,48.761 V 43.435 H 0 m 0,79.338 h 40.221 v 30.394 c -0.919,1.225 -1.378,2.664 -1.378,4.317 v 5.969 c 0,0.611 -0.245,1.163 -0.735,1.652 -0.429,0.429 -0.98,0.643 -1.654,0.643 H 0 m 0,14.417 h 36.454 c 4.654,0 8.602,-1.653 11.846,-4.959 3.306,-3.245 4.959,-7.162 4.959,-11.753 v -5.969 c 0,-1.715 -0.489,-3.184 -1.468,-4.408 v -30.303 h 5.601 c 1.897,0 3.52,-0.672 4.867,-2.021 1.347,-1.284 2.019,-2.877 2.019,-4.774 v -5.327 h 12.03 c 3.734,0 6.917,-1.345 9.55,-4.039 2.633,-2.633 3.949,-5.816 3.949,-9.55 v -3.49 h 16.161 c 4.714,0 8.754,-1.684 12.12,-5.051 3.369,-3.366 5.051,-7.438 5.051,-12.211 v -267.4 c 0,-4.715 -1.682,-8.754 -5.051,-12.121 -2.447,-2.449 -5.233,-4.01 -8.355,-4.684 v -3.212 c 0,-1.594 -0.581,-2.971 -1.745,-4.133 -1.162,-1.104 -2.54,-1.655 -4.133,-1.655 h -6.151 c 0,-4.162 -1.469,-7.744 -4.409,-10.742 -2.998,-2.939 -6.58,-4.408 -10.743,-4.408 -4.162,0 -7.744,1.469 -10.744,4.408 -2.938,2.998 -4.407,6.58 -4.407,10.742 H 0 M 97.519,70.432 c -1.469,1.408 -3.184,2.111 -5.142,2.111 H 0",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(133.7954,155.5518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 19.743 v -44.994 c -0.245,-8.201 4.041,-12.488 12.856,-12.856 H 62.442 V -75.297 H 31.221 C 11.325,-75.848 0.918,-67.277 0,-49.586 Z m 425.893,0 h 19.743 v -49.586 c -0.919,-17.691 -11.326,-26.262 -31.221,-25.711 h -31.222 v 17.447 h 29.844 c 8.815,0.368 13.1,4.655 12.856,12.856 z M 62.442,442.422 H 32.599 C 23.784,442.054 19.498,437.77 19.743,429.566 V 384.571 H 0 v 49.587 c 0.918,17.691 11.325,26.261 31.221,25.711 h 31.221 z m 320.751,17.447 h 31.222 c 19.895,0.55 30.302,-8.02 31.221,-25.711 v -49.587 h -19.743 v 44.995 c 0.244,8.204 -4.041,12.488 -12.856,12.856 h -29.844 z",
    style: {
      fill: "#333333",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path72"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5bfb299eb103f1a078892ec760355831.svg";
export { ForwardRef as ReactComponent };